export default "__VITE_ASSET__vUxKEeyL__"